import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import {
  EmptyFeedList,
  StyledFeedList,
  FeedListHeader,
  FeedListItem,
  NameContainer,
  Name,
  Start,
  End,
  Rows,
  Devices,
  DevicesHeader,
  Networks,
  Airings,
  AiringsHeader,
  Brands,
  Titles,
  Country,
  PbseVersion,
  FeedListItemContent,
  FeedItemStatusIcon
} from "./styles";

import { formatNum, formatDate } from "../../utils";
import {
  selectIconByStatus,
  buyOrContentTypeFeeds,
  buyOrContentTypeFeedsParam,
  buyOrContentTypeMapping
} from "../../constants";

export const FeedList = ({ feeds, history, expand, type }) => {
  if (feeds.length === 0) {
    return <EmptyFeedList>No feeds with this status</EmptyFeedList>;
  }

  // Sort feeds by created_at so that the most recently created ones appear first
  const sortedFeeds = feeds.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <StyledFeedList expand={expand}>
      <FeedListHeader>
        <Start>Start</Start>
        <End>End</End>
        <Rows># of Rows</Rows>
        <DevicesHeader># of Devices</DevicesHeader>
        <Networks># of Networks</Networks>
        {type.indexOf("viewership") > -1 ? (
          <Titles># of Titles</Titles>
        ) : (
          <>
            <AiringsHeader># of Airings</AiringsHeader>
            <Brands># of Brands</Brands>
          </>
        )}
        <Country>Country</Country>
        <PbseVersion>PBSE Version</PbseVersion>
        {buyOrContentTypeFeeds[type] && (  
          <Country>{buyOrContentTypeFeeds[type]}</Country>
        )}
      </FeedListHeader>
      {sortedFeeds.map(feed => {
        return (
          <FeedListItem key={feed.id}>
            <FeedListItemContent
              onClick={() =>
                history.push(`/clients/${feed.client_id}/feeds/${feed.id}`)
              }
            >
              <FeedItemStatusIcon>
                {selectIconByStatus(feed.status)}
              </FeedItemStatusIcon>
              <NameContainer>
                <Name>{feed.client_name}</Name>
                <Name>{feed.name}</Name>
              </NameContainer>

              <Start isNull={!feed.service_start}>
                {formatDate(feed.service_start)}
              </Start>
              <End isNull={!feed.service_stop}>
                {formatDate(feed.service_stop)}
              </End>
              <Rows isNull={!feed.row_cnt}>{formatNum(feed.row_cnt)}</Rows>
              <Devices isNull={!feed.device_cnt}>
                {formatNum(feed.device_cnt)}
              </Devices>
              <Networks isNull={!feed.network_cnt}>
                {formatNum(feed.network_cnt)}
              </Networks>
              {type.indexOf("viewership") < 0 ? (
                <>
                  <Airings isNull={!feed.airing_cnt}>
                    {formatNum(feed.airing_cnt)}
                  </Airings>
                  <Brands isNull={!feed.brand_cnt}>
                    {formatNum(feed.brand_cnt)}
                  </Brands>
                </>
              ) : (
                <Titles isNull={!feed.title_cnt}>
                  {formatNum(feed.title_cnt)}
                </Titles>
              )}
              <Country>
                <i
                  className={`flag-icon flag-icon-${feed.country.toLowerCase()}`}
                />
              </Country>
              <PbseVersion>{feed.pbse_version}</PbseVersion>
              {Object.keys(buyOrContentTypeFeeds).indexOf(feed.type) > -1 && (
                <PbseVersion>
                  {feed.misc_json &&
                    buyOrContentTypeMapping[
                      feed.misc_json[buyOrContentTypeFeedsParam[type]]
                    ]}
                </PbseVersion>
              )}
            </FeedListItemContent>
            {/* <EllipseIcon /> */}
          </FeedListItem>
        );
      })}
    </StyledFeedList>
  );
};

FeedList.defaultProps = {
  expand: false
};

FeedList.propTypes = {
  feeds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      client_id: PropTypes.number,
      created_at: PropTypes.string,
      delivery_schedule: PropTypes.string,
      kantar_filter_expression: PropTypes.shape({
        brand: PropTypes.arrayOf(PropTypes.string)
      }),
      name: PropTypes.string,
      pdp_infomediary: PropTypes.string,
      progress_ids: PropTypes.arrayOf(PropTypes.string),
      quality_metrics: PropTypes.shape({
        final_rowcount: PropTypes.number
      }),
      service_start: PropTypes.string,
      status: PropTypes.string,
      row_cnt: PropTypes.string,
      device_cnt: PropTypes.string,
      title_cnt: PropTypes.string,
      network_cnt: PropTypes.string,
      airing_cnt: PropTypes.string,
      brand: PropTypes.string,
      updated_at: PropTypes.string
    })
  ),
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  expand: PropTypes.bool,
  type: PropTypes.string
};

export default withRouter(FeedList);
